import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { insurancePurchasePromise } from '../../../../../store/postage-purchase/postage-purchase.api';
import { updateShipsuranceBalance } from '../../../../../store/seller/seller.actions';

const usePurchaseInsurance = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useAsyncSafeState(false);
  const [errors, setErrors] = useAsyncSafeState([]);
  const [data, setData] = useAsyncSafeState(null);

  const purchaseInsurance = useCallback(
    async (currency) => {
      setLoading(true);
      setErrors([]);
      setData(null);
      try {
        const result = await insurancePurchasePromise(currency);
        setData(result);
        setLoading(false);
        dispatch(updateShipsuranceBalance(result.value));
        return result;
      } catch (e) {
        setErrors(e?.response?.data?.Errors ?? [{}]);
        setLoading(false);
        return null;
      }
    },
    [setLoading, setErrors, setData, dispatch],
  );

  return useMemo(() => {
    return {
      purchaseInsurance,
      loading,
      errors,
      data,
    };
  }, [purchaseInsurance, loading, errors, data]);
};

export default usePurchaseInsurance;
